<template>
  <div>
    <div :class="toggle ? 'expand_member pa-3' : ' collapse_member pa-3'">
      <v-row v-if="member">
        <v-col cols="6" sm="6" md="3" v-for="(item, i) in member" :key="i">
          <div>
            <v-card
              class="pa-2 d-flex justify-space-between"
              outlined
              flat
              :color="item.is_leader == 1 ? `#00634166` : ''"
            >
              <div class="d-flex">
                <v-avatar dark class="mr-2" size="45">
                  <img
                    :src="item.profile_picture ? item.profile_picture : ava"
                    alt="avatar"
                    class="obj_fit"
                  />
                </v-avatar>
                <div>
                  <b
                    v-snip="1"
                    :class="item.is_leader == 1 ? 'color_default' : ''"
                    >{{ item.name }}</b
                  >
                  <p
                    :class="
                      item.is_leader == 1
                        ? 'color_default small_txt ma-0'
                        : 'default_txt'
                    "
                  >
                    {{
                      item.is_leader == 1
                        ? "Leader"
                        : item.is_co_leader == 1
                        ? "Co-Leader"
                        : "Member"
                    }}
                  </p>
                </div>
              </div>
              <v-menu
                v-if="item.is_leader !== 1 && leader"
                offset-y
                nudge-bottom="5px"
                nudge-left="80px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list class="pa-0" color="#EDF1F0" dense>
                  <v-list-item link @click="giveOffice(item, 'leader')">
                    <v-list-item-title>Make Leader</v-list-item-title>
                  </v-list-item>
                  <v-list-item link @click="giveOffice(item, 'coleader')">
                    <v-list-item-title>{{
                      item.is_co_leader
                        ? "Dismiss as Co-Leader"
                        : "Make Co-Leader"
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card>
          </div>
        </v-col>
      </v-row>
      <div style="height: 30px"></div>
      <div class="control_height">
        <v-btn icon small @click="toggle = !toggle">
          <v-icon v-if="!toggle">mdi-chevron-down</v-icon>
          <v-icon v-if="toggle">mdi-chevron-up</v-icon>
        </v-btn>
      </div>
    </div>
    <v-snackbar v-model="snack" :timeout="-1"> Loading... </v-snackbar>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "listMember",
  props: ["group", "member", "leader"],
  computed: {
    ...mapState({
      ava: (state) => state.ava,
      id: (state) => state.id,
    }),
  },
  data() {
    return {
      dataSet: null,
      loading: false,
      snack: false,
      toggle: false,
    };
  },
  mounted() {},
  methods: {
    giveOffice(item, type) {
      this.snack = true;
      let body = {
        course_group_id: this.group.id,
        user_id: item.user_id,
      };
      if (type == "coleader") {
        let status = item.is_co_leader == 0 ? "assign" : "unassign";
        body["status"] = status;
      }
      let data = {
        path: `manage/course/group/member/assign/${type}`,
        body: body,
      };

      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.snack = false;
          this.$emit("refetch");
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.snack = false;
        });
    },
    toggling() {
      this.toggle != this.toggle;
    },
  },
};
</script>

<style scoped>
.expand_member {
  position: relative;
  height: max-content;
  transition: 0.5 all;
}
.collapse_member {
  position: relative;
  overflow: hidden;
  height: 105px;
  transition: 0.5 all;
}
.control_height {
  position: absolute;
  display: flex;
  justify-content: center;
  background: #fff;
  bottom: 0;
  left: 0;
  width: 100%;
  border-radius: 10px;
}
</style>
